import React, { useEffect } from 'react';
import { returnPaginationRange } from '../../utils/appUtils';

const Pagination = (props: any) => {
    useEffect(() => {
    }, [props.pageLimit, props.totalPageNumber, props.pageNumber, props.siblings])
    let array = returnPaginationRange(props.totalPageNumber, props.pageNumber, props.pageLimit, props.siblings)
    return(
        <ul className="pagination pagination-md justify-content-end">
            <li className="page-item"><span onClick={() => props.onPageChange("&laquo;")} className="page-link">&laquo;</span></li>
            <li className="page-item"><span onClick={() => props.onPageChange("&lsaquo;")} className="page-link">&lsaquo;</span></li>
            {array.map(value => {
                if (value === props.pageNumber) {
                    return(
                        <li key={value} className="page-item active"><span onClick={() => props.onPageChange(value)} className="page-link">{value}</span></li>
                    )
                } else {
                    return(
                        <li key={value} className="page-item"><span onClick={() => props.onPageChange(value)} className="page-link">{value}</span></li>
                    )
                }
            })}
            <li className="page-item"><span onClick={() => props.onPageChange("&rsaquo;")} className="page-link">&rsaquo;</span></li>
            <li className="page-item"><span onClick={() => props.onPageChange("&raquo;")} className="page-link">&raquo;</span></li>
        </ul>
    )
}

export default Pagination;